module.exports = __webpack_public_path__ + "img/map_oostkant.ec1191f5.png";